import { ChangeDetectorRef, Component } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-aggiungi-abbecedario-backoffice',
  templateUrl: './aggiungi-abbecedario-backoffice.component.html',
  styleUrl: './aggiungi-abbecedario-backoffice.component.css'
})
export class AggiungiAbbecedarioBackofficeComponent {

  constructor(private apiService: ApiService, private router: Router, private cdr: ChangeDetectorRef) { }

  formDefinizione!: FormGroup;

  alfabeto: { lettera: string }[] = [
    { lettera: "A" },
    { lettera: "B" },
    { lettera: "C" },
    { lettera: "D" },
    { lettera: "E" },
    { lettera: "F" },
    { lettera: "G" },
    { lettera: "H" },
    { lettera: "I" },
    { lettera: "J" },
    { lettera: "K" },
    { lettera: "L" },
    { lettera: "M" },
    { lettera: "N" },
    { lettera: "O" },
    { lettera: "P" },
    { lettera: "Q" },
    { lettera: "R" },
    { lettera: "S" },
    { lettera: "T" },
    { lettera: "U" },
    { lettera: "V" },
    { lettera: "W" },
    { lettera: "X" },
    { lettera: "Y" },
    { lettera: "Z" },
  ]

  ngOnInit(): void {

    this.formDefinizione = new FormGroup({
      alfabeto: new FormControl(null, Validators.required),
      titolo: new FormControl(null, Validators.required),
      definizione: new FormControl(null, Validators.required)
    })

  }

  onDefinizione(e: any) {
    this.cdr.detectChanges();
  }

  onSubmit() {

    let definizione = {
      alfabeto: this.formDefinizione.get('alfabeto')?.value.lettera,
      titolo: this.formDefinizione.get('titolo')?.value,
      definizione: this.formDefinizione.get('definizione')?.value
    }

    this.apiService.addDefinizione(definizione).subscribe({
      next: (data) => this.apiService.setDefinizioni(),
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.router.navigate(['/backoffice/abbecedario'])
      }
    })

  }

}
